import React from "react";
import { useLiveQuery } from "dexie-react-hooks";
import { observer } from "mobx-react-lite";
import { getWaybillNoDocumentNumberResult } from "@/services/db/waybillNoDocument";
import EwaybillDTO from "@/dto/order/EwaybillDTO";

interface WaybillPrintDocumentNumberProps {
    ewaybill: EwaybillDTO;
}

const LocalDBFallback: React.FC<WaybillPrintDocumentNumberProps> = observer(function (props) {
    const { ewaybill } = props;

    const result = useLiveQuery(async () => {
        if (!ewaybill.waybillNo) return null;

        return await getWaybillNoDocumentNumberResult(ewaybill.waybillNo);
    }, [ewaybill.waybillNo]);

    if (!result) {
        return null;
    }

    return (
        <span style={{ zoom: 0.8, userSelect: "none", marginLeft: -5 }}>
            <span>{"　"}</span>
            <span>{`${result.documentNumber}/${result.totalNumber}`}</span>
        </span>
    );
});

/**前后端都保存一份序号数据，优先使用后端数据，没有则使用前端数据 */
const WaybillPrintDocumentNumber: React.FC<WaybillPrintDocumentNumberProps> = function (props) {
    const { ewaybill } = props;

    if (!ewaybill?.waybillNo) return null;

    if (ewaybill?.printIndex) {
        return (
            <span style={{ zoom: 0.8, userSelect: "none", marginLeft: -5 }}>
                <span>{"　"}</span>
                <span>{ewaybill.printIndex}</span>
            </span>
        );
    }

    return <LocalDBFallback ewaybill={ewaybill} />;
};

export default observer(WaybillPrintDocumentNumber);
